<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<script setup lang="ts">
import type { PropType } from 'vue'

type CalendarWeekdays = 0 | 1 | 2 | 3 | 4 | 5 | 6

interface CDatePickerProps {
  rounded?: string | number | boolean
  variant?:
  | 'filled'
  | 'outlined'
  | 'plain'
  | 'underlined'
  | 'solo'
  | 'solo-inverted'
  | 'solo-filled'
  format?: string
  displayFormat?: string
  min?: string | Date
  max?: string | Date
  showAdjacentMonths?: boolean
  multiple?: boolean
  range?: boolean
  showWeek?: boolean
  weekdays?: CalendarWeekdays[]
  firstDayOfWeek?: number | string
  allowedDates?: unknown[] | ((date: unknown) => boolean)
}

const props = defineProps({
  color: {
    type: String,
    default: '',
  },
  rounded: {
    type: String as PropType<CDatePickerProps['rounded']>,
    default: 'xl',
  },
  variant: {
    type: String as PropType<CDatePickerProps['variant']>,
    default: 'outlined',
    validator: (value: string): boolean =>
      [
        'filled',
        'outlined',
        'plain',
        'underlined',
        'solo',
        'solo-inverted',
        'solo-filled',
      ].includes(value),
  },
  label: {
    type: String,
    default: 'Seleccionar fecha',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  hiddenDetail: {
    type: Boolean,
    default: true,
  },
  singleLine: {
    type: Boolean,
    default: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  format: {
    type: String as PropType<CDatePickerProps['format']>,
    default: 'YYYY-MM-DD',
  },
  displayFormat: {
    type: String as PropType<CDatePickerProps['displayFormat']>,
    default: 'DD/MM/YYYY',
  },
  min: {
    type: [String, Date] as PropType<CDatePickerProps['min']>,
    default: undefined,
  },
  max: {
    type: [String, Date] as PropType<CDatePickerProps['max']>,
    default: undefined,
  },
  showAdjacentMonths: {
    type: Boolean as PropType<CDatePickerProps['showAdjacentMonths']>,
    default: true,
  },
  multiple: {
    type: Boolean as PropType<CDatePickerProps['multiple']>,
    default: false,
  },
  range: {
    type: Boolean as PropType<CDatePickerProps['range']>,
    default: false,
  },
  showWeek: {
    type: Boolean as PropType<CDatePickerProps['showWeek']>,
    default: false,
  },
  weekdays: {
    type: Array as PropType<CDatePickerProps['weekdays']>,
    default: () => [0, 1, 2, 3, 4, 5, 6] as CalendarWeekdays[],
  },
  firstDayOfWeek: {
    type: [Number, String] as PropType<CDatePickerProps['firstDayOfWeek']>,
    default: 0,
  },
  allowedDates: {
    type: [Array, Function] as PropType<CDatePickerProps['allowedDates']>,
    default: undefined,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  appendIcon: {
    type: String,
    default: '$calendar',
  },
})

const emits = defineEmits({
  changed: (event: any) => true,
})

const model = defineModel()
</script>

<template>
  <v-text-field :label="props.label" :variant="props.variant" :hide-details="props.hiddenDetail"
    :single-line="props.singleLine" :rounded="props.rounded" :loading="props.loading" :disabled="props.disabled"
    :readonly="props.readonly" :color="props.color" :clearable="props.clearable" :append-inner-icon="props.appendIcon"
    density="comfortable" v-model="model" @update:model-value="emits('changed', $event)">
    <v-menu activator="parent" :close-on-content-click="false">
      <v-date-picker :color="props.color" :min="props.min" :max="props.max"
        :show-adjacent-months="props.showAdjacentMonths" :multiple="props.multiple" :range="props.range"
        :show-week="props.showWeek" :weekdays="props.weekdays" :first-day-of-week="props.firstDayOfWeek"
        :allowed-dates="props.allowedDates" v-model="model"
        @update:model-value="emits('changed', $event)"></v-date-picker>
    </v-menu>
  </v-text-field>
</template>
